import React from "react";
import LittleFooter from "../components/LittleFooter";
import style from "../style/PrivacyPolicy.module.scss";
import { useQuery } from "react-query";
import axios from "axios";
import DOMPurify from "dompurify";
import styled from "styled-components";

const TopContainer = styled.div`
  ul {
    list-style-type: disc;
  }
`;
const BottomContainer = styled.div`
  ul {
    list-style-type: disc;
    ul {
      list-style-type: decimal;
      padding-left: 10px;
      ul {
        counter-reset: my-counter;
        padding-left: 20px;
        list-style-type: none;
        & > li {
          counter-increment: my-counter;
          &::before {
            content: "(" counter(my-counter) ")";
          }
        }
      }
    }
  }
`;

function PrivacyPolicy() {
  const apiUrl = import.meta.env.VITE_API_ROOT_URL
  const getReferralLine = async () => {
    const res = await axios.get(`${apiUrl}api/term/ReferralLineAnnouncement`);
    return res?.data?.Data?.Content;
  };

  const getReferralPrivacy = async () => {
    const res = await axios.get(`${apiUrl}api/term/ReferralPrivacy`);
    return res?.data?.Data?.Content;
  };
  const { data: ReferralLineData } = useQuery(
    "getReferralLine",
    getReferralLine
  );
  const { data: ReferralPrivacyData } = useQuery(
    "getReferralPrivacy",
    getReferralPrivacy
  );
  // console.log(ReferralPrivacyData);
  return (
    <div className={style.privacy_body}>
      <div className={style.privacy_background}></div>
      <svg
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1921 273"
        className={style.triangle}
      >
        <polygon fill="#fff" points="0,273 1921,273 1921,0 "></polygon>
      </svg>
      <div className={style.content_body}>
        <div className={style.logo}>
          <img src="./end_logo.svg" alt="" style={{ width: "100px " }} />
        </div>
        <div className={style.content}>
          <TopContainer className={style.top}>
            <div className={style.title}>
              <div className={style.left_title}>LINE使用宣告</div>
              <div className={style.right_title}>
                最後更新日期：2023 年 03 月 01 日
              </div>
            </div>
            <div
              className={style.top_content}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(ReferralLineData),
              }}
            ></div>
          </TopContainer>
          <BottomContainer className={style.bottom}>
            <div className={style.title}>
              <div className={style.left_title}>服務條款及隱私權保護政策</div>
              <div className={style.right_title}>
                最後更新日期：2023 年 03 月 01 日
              </div>
            </div>
            <div
              className={style.bottom_content}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(ReferralPrivacyData),
              }}
            >
              {/* <ul className={style.first_list}>
                <li>
                  服務條款
                  <ul className={style.second_list}>
                    <li>認知與接受條款：</li>
                    <p>
                      聯新神經醫學中心係依據本服務條款提供服務 (
                      以下簡稱「本服務」 )
                      。當您使用本網站時，即表示您已閱讀、瞭解並同意接受本約定書之所有內容。聯新神經醫學中心有權於任何時間修改或變更本約定書之內容，修改或變更後之條款自於本網站公告時生效，建議您應隨時注意該等修改或變更。您於任何修改或變更後繼續使用本網站，視為您已閱讀、瞭解並同意接受該等修改或變更。如果您不同意本約定書的內容，或者您所屬的國家或地域排除本約定書內容之全部或一部時，您應立即停止使用本網站。若您為未滿二十歲（或您所屬國家、地域之法定成年年齡），除應符合上述規定外，並應於您的家長（或監護人）閱讀、瞭解並同意本約定書之所有內容及其後修改變更後，方得使用或繼續使用本網站。當您使用或繼續使用本網站時，即表示您的家長（或監護人）已閱讀、瞭解並同意接受本約定書之所有內容及其後修改變更。
                    </p>
                    <li>您的註冊義務：</li>
                    <p>
                      若本網站提供註冊服務時，為了能使用本服務，您同意以下事項：
                    </p>
                    <ul className={style.third_list}>
                      <li>
                        依本服務註冊表之提示提供您本人正確、最新及完整的資料。
                      </li>
                      <li>
                        維持並更新您個人資料，確保其為正確、最新及完整。若您提供任何錯誤或不實的資料，聯新神經醫學中心有權暫停或終止您的帳號，並拒絕您使用本服務之全部或一部。
                      </li>
                    </ul>
                    <li>隱私權政策：</li>
                    <p>
                      關於您的會員註冊以及其他特定資料依下文聯新神經醫學中心「隱私權政策」受到保護與規範。
                    </p>
                    <li>會員帳號、密碼及安全：</li>
                    <p>
                      完成本服務的註冊申請後，您將擁有一個密碼及帳號。維持密碼及帳號的機密安全，是您的責任。利用該密碼及帳號所進行的一切行動，您將負完全的責任。您並同意以下事項：
                      (a)
                      您的密碼或帳號遭到盜用或有其他任何安全問題發生時，您將立即通知聯新神經醫學中心，且
                      (b)
                      除透過聯新動脈取栓LINE官方帳號外，每次連線完畢均結束您的帳號使用。
                    </p>
                    <li>使用者的守法義務及承諾：</li>
                    <p>
                      您承諾絕不為任何非法目的或以任何非法方式使用本網站，並承諾遵守中華民國相關法規及一切使用網際網路之國際慣例。您若係中華民國以外之使用者，並同意遵守所屬國家或地域之法令。您同意並保證不得利用本網站從事侵害他人權益或違法之行為，包括但不限於：
                    </p>
                    <ul className={style.third_list}>
                      <li>
                        公布或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、種族歧視、違反公共秩序或善良風俗或其他不法之文字、圖片或任何形式的檔案於本網站上；
                      </li>
                      <li>
                        侵害他人名譽、隱私權、營業秘密、商標權、著作權、專利權、其他智慧財產權及其他權利；
                      </li>
                      <li>違反依法律或契約所應負之保密義務；</li>
                      <li>冒用他人名義使用本服務；</li>
                      <li>傳輸或散佈電腦病毒或其他惡意程式；</li>
                      <li>從事不法交易行為或張貼虛假不實、引人犯罪之訊息；</li>
                      <li>販賣槍枝、毒品、禁藥、盜版軟體或其他違禁物；</li>
                      <li>提供賭博資訊或以任何方式引誘他人參與賭博；</li>
                      <li>濫發廣告郵件；</li>
                      <li>其他聯新神經醫學中心有正當理由認為不適當之行為。</li>
                    </ul>
                    <p>
                      您須對張貼或發放於本網站上之內容負責任，並就有關資料而引起對聯新神經醫學中心之請求、訴訟或有關程序為補償或賠償（包括但不限於訴訟費用及律師費用等）。就任何使用者在本網站張貼或發放之資料或內容
                      (
                      無論該資料或內容是否令人反感、不當或侵犯您於中華民國或其他國家法律賦予之權利
                      )
                      ，您同意放棄所擁有或可能擁有向聯新神經醫學中心追索之權利。聯新神經醫學中心保留隨時修改、刪除或拒絕您於本網站張貼任何資料之權利。
                    </p>
                    <li>關於使用及儲存之一般措施：</li>
                    <p>
                      您同意聯新神經醫學中心得就本網站所提供之服務訂定一般措施及限制。若聯新神經醫學中心將本網站提供之服務維持或傳送之任何訊息、通訊和內容刪除或未予儲存，啟用帳號即表示同意聯新神經醫學中心毋須承擔任何責任、長時間未使用的帳號，聯新神經醫學中心有權關閉。同時聯新神經醫學中心有權依其服務之考量，不論通知與否，隨時變更這些一般措施及限制。
                    </p>
                    <li>服務中斷或故障 ：</li>
                    <p>
                      本服務存在中斷或故障等風險，使用者於使用本服務時，應自行採取防護措施，若因此造成使用者於使用上的不便利、資料之喪失、錯誤、遭人無故入侵、干擾、破壞、變更或其他經濟上損失情形，聯新神經醫學中心對使用者因為使用或無法使用本服務而造成的損害，不負任何賠償責任。
                    </p>
                    <li>免責聲明：</li>
                    <p>
                      原則上病歷的取得須經病人本人或其法定代理人的書面同意，但不論是您或是聯新神經醫學中心所提供之病患資訊，皆屬於以下依個人資料保護法無須經病人同意之情況，因而予以提供：
                    </p>
                    <ul className={style.third_list}>
                      <li>
                        相關醫療機構及醫療人員:
                        為了醫療之目的醫療人員須參考病歷資料；
                      </li>
                      <li>有正當理由而僅供內部使用者；</li>
                      <li>
                        為免除當事人之生命、身體自由或財產上之急迫危險者；
                      </li>
                      <li>為學術研究而有必要且無害於當事人之重大利益者；</li>
                      <li>有利於當事人權益者；</li>
                    </ul>
                    <p>
                      若未符合上述情況或其他法律允許之事宜，因您提供資料衍生之法律責任，您應負完全責任。
                    </p>
                    <li>智慧財產權的保護：</li>
                    <p>
                      本服務網站所使用之軟體或程式、網站上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、網站架構、網站畫面的安排、網頁設計，均由聯新神經醫學中心或其他權利人依法擁有其智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。任何人不得逕自使用、修改、重製、公開播送、改作、散布、發行、公開發表、進行還原工程、解編或反向組譯。若您欲引用或轉載前述軟體、程式或網站內容，必須依法取得聯新神經醫學中心或其他權利人的事前書面同意。尊重智慧財產權是您應盡的義務，如有違反，您應對聯新神經醫學中心負損害賠償責任（包括但不限於訴訟費用及律師費用等）。
                    </p>
                    <li>拒絕或終止您的使用：</li>
                    <p>
                      您同意聯新神經醫學中心得基於其自行之考量，因任何理由，包含但不限於缺乏使用，或聯新神經醫學中心認為您已經違反本約定書的明文規定及精神，終止您的密碼、帳號（或其任何部分）或本服務網站之使用。聯新神經醫學中心亦得依其自行之考量，於通知或未通知之情形下，隨時終止本服務網站或其任何部分。您同意依本約定書任何規定提供之本網站之服務，無需進行事先通知即得終止，您承認並同意，聯新神經醫學中心得立即關閉或刪除您的帳號及您帳號中所有相關資料及檔案，及停止本網站之使用。此外，您同意若本網站服務之使用被終止，聯新神經醫學中心對您或任何第三人均不承擔責任。
                    </p>
                    <li>準據法與管轄法院：</li>
                    <p>
                      本約定書之解釋與適用，以及與本約定書有關的爭議，均應依照中華民國法律予以處理，並以台灣桃園地方法院為第一審管轄法院。
                    </p>
                  </ul>
                </li>
                <li>隱私權保護政策</li>
                <p>
                  聯新國際醫療集團及其所屬公司(以下簡稱聯新國際醫院)非常重視用戶的隱私權，因此制訂了隱私權保護政策。請你細讀以下有關隱私權保護政策的內容。
                </p>
                <ul className={style.second_list}>
                  <li>隱私權保護之適用範圍：</li>
                  <p>
                    本隱私權保護政策內容，包括聯新國際醫院如何處理在用戶使用網站服務時收集到的身份識別資料，也包括聯新國際醫院如何處理在商業伙伴與聯新國際醫院合作時分享的任何身份識別資料。
                  </p>
                  <p>
                    隱私權保護政策不適用於聯新國際醫院以外的公司，也不適用於非聯新國際醫院所僱用或管理的人員。
                  </p>
                  <li>資料收集及使用方式：</li>
                  <p>
                    聯新國際醫院在你註冊聯新神經醫學中心平台之帳號、使用聯新國際醫院的產品或服務、瀏覽聯新國際醫院網頁時，聯新國際醫院會收集你的個人識別資料。
                  </p>
                  <p>
                    聯新國際醫院也自動接收並紀錄你瀏覽器上的伺服器數值，包括互聯網協定位址
                    (IP Address) 、聯新國際醫院 cookie
                    中的資料及你要求取用的網頁紀錄。
                  </p>
                  <li>資料蒐集及使用之目的：</li>
                  <p>
                    聯新國際醫院可能會使用資料作以下用途：改進為你提供的網頁內容、完成你對某項服務的要求及通知你相關資訊等。
                  </p>
                  <li>資料分享及公開方式：</li>
                  <p>聯新國際醫院不會向任何人出售或出借你的個人識別資料。</p>
                  <p>
                    在以下的情況下，聯新國際醫院會向其他人士或聯新國際醫院集團以外公司提供你的個人識別資料：
                  </p>
                  <ul className={style.third_list}>
                    <li>與其他人士或公司共用資料前，取得你的同意。</li>
                    <li>
                      需要與其他人士或公司共用你的資料，才能夠提供你要求的產品或服務。
                    </li>
                    <li>
                      向代表聯新國際醫院提供服務或產品的公司提供資料，以便向你提供產品或服務
                      (
                      若我們沒有事先通知並取得你的同意，這些公司均無權使用我們提供的個人資料，作提供產品或服務以外的其他用途
                      ) 。
                    </li>
                    <li>
                      應遵守法令或政府機關的要求；或我們發覺你在網站上的行為違反聯新國際醫院服務條款
                      或產品、服務的特定使用指南。
                    </li>
                    <li>
                      在聯新國際醫院集團內公司併購或重組的情況下，於業務交接期間，向曾經屬於聯新國際醫院集團內部的公司提供您的個人識別資料。
                    </li>
                  </ul>
                  <p>
                    為了保護使用者個人隱私，我們無法為您查詢其他使用者的帳號資料，請您見諒！
                  </p>
                  <li>Cookies：</li>
                  <p>本網站會到你的電腦設定並取用聯新國際醫院cookie。</p>
                  <p>
                    cookie能令網站於您的電腦中儲存少量的資料，以方便日後能檢索該等資料。cookie乃一組儲存在您電腦純文字檔案中的符號，該等符號將傳送至您電腦中裝有互聯網瀏覽器檔案的硬碟。
                  </p>
                  <p>
                    聯新國際醫院使用暫時性的cookie，使您更容易地瀏覽本網站。該cookie並不會永久性地儲存在您的電腦硬碟，而將於您離開本網站時被刪除。
                  </p>
                  <p>
                    聯新國際醫院持續地使用cookie的目的在於準確地記錄網站使用者的數目、識別您曾否確認為某一國家或地區之居民、及醫療或其他專業人士，並紀錄您所指定的自訂項目和偏好。
                  </p>
                  <p>我們所使用的cookie並不會包含任何個人資料。</p>
                  <p>
                    使用者如對我們所使用之cookie有所顧慮，可選擇使用存於您電腦瀏覽器軟體中的刪掉、阻礙所有的cookie的功能，或於cookie儲存或互換前，電腦出現有關警告使用者之字句。值得注意的是，倘若您選用有關的功能，本網站之部份網頁未必能正常運作，或於運作時將比較緩慢。
                  </p>
                  <li>修改個人帳號資料及偏好設定：</li>
                  <p>
                    聯新國際醫院賦予你在任何時候閱覽、複製、更正、停止個人聯新國際醫院帳號資料及偏好設定的權力，及要求刪除個人資料的權利，及是否接受聯新國際醫院通知你的決定權。
                  </p>
                  <p>
                    當您要求停止個人聯新國際醫院帳號資料，或要求刪除關於您的個人資料時，聯新國際醫院將無法提供相關網站服務給您。
                  </p>
                  <li>保全：</li>
                  <p>
                    為保障你的隱私及安全，你的聯新國際醫院帳號資料會用密碼保護。聯新國際醫院將會採取合理措施以保障我們擁有的個人資料避免遺失、被不當使用和在沒有授權的情況下被接觸、披露、更改或破壞。
                  </p>
                  <li>政策修訂：</li>
                  <p>
                    在法律許可的範圍內，聯新國際醫院保留其修改、增加或刪除部份有關此政策之權利，倘若我們修改此政策條款、我們定將有關修改部份刊登於本網站，使您隨時能得悉我們收集何等個人資料，如何使用有關之資料及會否將有關之個人資料披露給他人等事宜。
                  </p>
                </ul>
              </ul> */}
            </div>
          </BottomContainer>
        </div>
      </div>
      <LittleFooter />
    </div>
  );
}

export default PrivacyPolicy;
